export default function(
  fn: any,
  idleTimeout = 20000,
) {
  if (!window) {
    return
  }

  if (window.requestIdleCallback) {
    window.requestIdleCallback(fn, { timeout: idleTimeout })
  } else {
    window.requestAnimationFrame(fn)
  }
}
